import { View, Text, Dimensions, ScrollView, Pressable } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import {
  getSingleUser,
  getUser,
} from "../../../services/ProfileSettings/ProfileSettingService";
import { RootState, useSelector } from "../../../redux/store";
import ProfileCard from "../../HomeFeed/HomeFeedComponents/ProfileCard";
import UserProfileDetails from "../../HomeFeed/HomeFeedComponents/UserProfileDetails";
import UserExperiences from "../../HomeFeed/HomeFeedComponents/UserExperiences";
import FeedIcons from "../../../assets/Icons/FeedIcons";

interface Profile {
  _id: string;
  photos: Array<string>;
  age: number;
  bio: string;
  gender: string;
  userInfo: {
    height: string;
    drinker: boolean;
    smoker: boolean;
    ethnicity: string;
    currentPosition: string;
    educationLevel: string;
    relationshipStatus: string;
  };
  preferences: {
    seeking: string;
  };
  isVerified: boolean;
  firstName: string;
  interestedExperiences: any;
}

export default function PreviewProfile({
  toggleModal,
  data,
}: {
  toggleModal: any;
  data: any;
}) {
  const height = Dimensions.get("window").height;
  const [currentProfile, setCurrentProfile] = useState(data);
  const [viewableItems, setViewableItems] = useState([]);
  const [index, setIndex] = useState(0);

  // async function getUserData() {
  //   const response = await getSingleUser(userToken);

  //   console.log("====================================");
  //   console.log("data", response);
  //   console.log("====================================");
  //   setCurrentProfile(response.data);
  // }
  // useEffect(() => {
  //   // Fetch profiles when the component mounts
  //   getUserData();
  // }, []);

  const handleOnViewableItemsChanged = useRef(
    ({ viewableItems }: { viewableItems: any }) => {
      setViewableItems(viewableItems);
      setIndex(viewableItems[0].index);
    }
  ).current;

  const viewabilityConfig = useRef({
    itemVisiblePercentThreshold: 50,
  }).current;
  return (
    <ScrollView
      style={{
        backgroundColor: "white",
        height: "100%",
      }}
    >
      {currentProfile != null && (
        <ProfileCard
          currentProfile={currentProfile}
          height={height}
          index={index}
          handleOnViewableItemsChanged={handleOnViewableItemsChanged}
          viewabilityConfig={viewabilityConfig}
          interest={false}
          chatProfile={false}
          imageHeight={200}
        />
      )}
      {currentProfile != null && (
        <UserProfileDetails currentProfile={currentProfile} />
      )}
      {currentProfile?.interestedExperiences?.length > 0 && (
        <UserExperiences
          currentProfile={currentProfile}
          interest={false}
          chatProfile={false}
          imageHeight={200}
        />
      )}
      <Pressable
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          zIndex: 2,
        }}
        onPress={toggleModal}
      >
        <FeedIcons.WhiteClose />
      </Pressable>
    </ScrollView>
  );
}
